import { useQuery } from 'react-query';

import { useCurrentUser } from '@qualio/ui-components';

import eventActionLogApi from '../api/eventActionLog.api';

export const EventActionLogQueryKey = 'eventActionList';

export const useEventActionLog = (eventId: number) => {
  const { companyId } = useCurrentUser();
  const enabled = !Number.isNaN(eventId) && eventId > 0;

  return useQuery(
    [EventActionLogQueryKey, companyId, eventId],
    () => eventActionLogApi.getEventActionLogs(companyId, eventId),
    { enabled },
  );
};
